const countries = [
    {
        name: "Afghanistan",
        turkish_name: "Afganistan",
        dial_code: "+93",
        code: "AF",
    },
    {
        name: "Aland Islands",
        turkish_name: "Aland Adaları",
        dial_code: "+358",
        code: "AX",
    },
    {
        name: "Albania",
        turkish_name: "Arnavutluk",
        dial_code: "+355",
        code: "AL",
    },
    {
        name: "Algeria",
        turkish_name: "Cezayir",
        dial_code: "+213",
        code: "DZ",
    },
    {
        name: "AmericanSamoa",
        turkish_name: "Amerikan Samoası",
        dial_code: "+1684",
        code: "AS",
    },
    {
        name: "Andorra",
        turkish_name: "Andorra",
        dial_code: "+376",
        code: "AD",
    },
    {
        name: "Angola",
        turkish_name: "Angola",
        dial_code: "+244",
        code: "AO",
    },
    {
        name: "Anguilla",
        turkish_name: "Anguilla",
        dial_code: "+1264",
        code: "AI",
    },
    {
        name: "Antarctica",
        turkish_name: "Antarktika",
        dial_code: "+672",
        code: "AQ",
    },
    {
        name: "Antigua and Barbuda",
        turkish_name: "Antigua ve Barbuda",
        dial_code: "+1268",
        code: "AG",
    },
    {
        name: "Argentina",
        turkish_name: "Arjantin",
        dial_code: "+54",
        code: "AR",
    },
    {
        name: "Armenia",
        turkish_name: "Ermenistan",
        dial_code: "+374",
        code: "AM",
    },
    {
        name: "Aruba",
        turkish_name: "Aruba",
        dial_code: "+297",
        code: "AW",
    },
    {
        name: "Australia",
        turkish_name: "Avustralya",
        dial_code: "+61",
        code: "AU",
    },
    {
        name: "Austria",
        turkish_name: "Avusturya",
        dial_code: "+43",
        code: "AT",
    },
    {
        name: "Azerbaijan",
        turkish_name: "Azerbaycan",
        dial_code: "+994",
        code: "AZ",
    },
    {
        name: "Bahamas",
        turkish_name: "Bahamalar",
        dial_code: "+1242",
        code: "BS",
    },
    {
        name: "Bahrain",
        turkish_name: "Bahreyn",
        dial_code: "+973",
        code: "BH",
    },
    {
        name: "Bangladesh",
        turkish_name: "Bangladeş",
        dial_code: "+880",
        code: "BD",
    },
    {
        name: "Barbados",
        turkish_name: "Barbados",
        dial_code: "+1246",
        code: "BB",
    },
    {
        name: "Belarus",
        turkish_name: "Belarus",
        dial_code: "+375",
        code: "BY",
    },
    {
        name: "Belgium",
        turkish_name: "Belçika",
        dial_code: "+32",
        code: "BE",
    },
    {
        name: "Belize",
        turkish_name: "Belize",
        dial_code: "+501",
        code: "BZ",
    },
    {
        name: "Benin",
        turkish_name: "Benin",
        dial_code: "+229",
        code: "BJ",
    },
    {
        name: "Bermuda",
        turkish_name: "Bermuda",
        dial_code: "+1441",
        code: "BM",
    },
    {
        name: "Bhutan",
        turkish_name: "Butan",
        dial_code: "+975",
        code: "BT",
    },
    {
        name: "Bolivia, Plurinational State of",
        turkish_name: "Bolivya",
        dial_code: "+591",
        code: "BO",
    },
    {
        name: "Bosnia and Herzegovina",
        turkish_name: "Bosna-Hersek",
        dial_code: "+387",
        code: "BA",
    },
    {
        name: "Botswana",
        turkish_name: "Botsvana",
        dial_code: "+267",
        code: "BW",
    },
    {
        name: "Brazil",
        turkish_name: "Brezilya",
        dial_code: "+55",
        code: "BR",
    },
    {
        name: "British Indian Ocean Territory",
        turkish_name: "Britanya Hint Okyanusu Toprakları",
        dial_code: "+246",
        code: "IO",
    },
    {
        name: "Brunei Darussalam",
        turkish_name: "Brunei",
        dial_code: "+673",
        code: "BN",
    },
    {
        name: "Bulgaria",
        turkish_name: "Bulgaristan",
        dial_code: "+359",
        code: "BG",
    },
    {
        name: "Burkina Faso",
        turkish_name: "Burkina Faso",
        dial_code: "+226",
        code: "BF",
    },
    {
        name: "Burundi",
        turkish_name: "Burundi",
        dial_code: "+257",
        code: "BI",
    },
    {
        name: "Cambodia",
        turkish_name: "Kamboçya",
        dial_code: "+855",
        code: "KH",
    },
    {
        name: "Cameroon",
        turkish_name: "Kamerun",
        dial_code: "+237",
        code: "CM",
    },
    {
        name: "Canada",
        turkish_name: "Kanada",
        dial_code: "+1",
        code: "CA",
    },
    {
        name: "Cape Verde",
        turkish_name: "Yeşil Burun Adaları",
        dial_code: "+238",
        code: "CV",
    },
    {
        name: "Cayman Islands",
        turkish_name: "Cayman Adaları",
        dial_code: "+ 345",
        code: "KY",
    },
    {
        name: "Central African Republic",
        turkish_name: "Orta Afrika Cumhuriyeti",
        dial_code: "+236",
        code: "CF",
    },
    {
        name: "Chad",
        turkish_name: "Çad",
        dial_code: "+235",
        code: "TD",
    },
    {
        name: "Chile",
        turkish_name: "Şili",
        dial_code: "+56",
        code: "CL",
    },
    {
        name: "China",
        turkish_name: "Çin",
        dial_code: "+86",
        code: "CN",
    },
    {
        name: "Christmas Island",
        turkish_name: "Christmas Adası",
        dial_code: "+61",
        code: "CX",
    },
    {
        name: "Cocos (Keeling) Islands",
        turkish_name: "Cocos (Keeling) Adaları",
        dial_code: "+61",
        code: "CC",
    },
    {
        name: "Colombia",
        turkish_name: "Kolombiya",
        dial_code: "+57",
        code: "CO",
    },
    {
        name: "Comoros",
        turkish_name: "Komorlar",
        dial_code: "+269",
        code: "KM",
    },
    {
        name: "Congo",
        turkish_name: "Kongo",
        dial_code: "+242",
        code: "CG",
    },
    {
        name: "Congo, The Democratic Republic of the Congo",
        turkish_name: "Demokratik Kongo Cumhuriyeti",
        dial_code: "+243",
        code: "CD",
    },
    {
        name: "Cook Islands",
        turkish_name: "Cook Adaları",
        dial_code: "+682",
        code: "CK",
    },
    {
        name: "Costa Rica",
        turkish_name: "Kosta Rika",
        dial_code: "+506",
        code: "CR",
    },
    {
        name: "Cote d'Ivoire",
        turkish_name: "Fildişi Sahili",
        dial_code: "+225",
        code: "CI",
    },
    {
        name: "Croatia",
        turkish_name: "Hırvatistan",
        dial_code: "+385",
        code: "HR",
    },
    {
        name: "Cuba",
        turkish_name: "Küba",
        dial_code: "+53",
        code: "CU",
    },
    {
        name: "Cyprus",
        turkish_name: "Kıbrıs",
        dial_code: "+357",
        code: "CY",
    },
    {
        name: "Czech Republic",
        turkish_name: "Çekya",
        dial_code: "+420",
        code: "CZ",
    },
    {
        name: "Denmark",
        turkish_name: "Danimarka",
        dial_code: "+45",
        code: "DK",
    },
    {
        name: "Djibouti",
        turkish_name: "Cibuti",
        dial_code: "+253",
        code: "DJ",
    },
    {
        name: "Dominica",
        turkish_name: "Dominika",
        dial_code: "+1767",
        code: "DM",
    },
    {
        name: "Dominican Republic",
        turkish_name: "Dominik Cumhuriyeti",
        dial_code: "+1849",
        code: "DO",
    },
    {
        name: "Ecuador",
        turkish_name: "Ekvador",
        dial_code: "+593",
        code: "EC",
    },
    {
        name: "Egypt",
        turkish_name: "Mısır",
        dial_code: "+20",
        code: "EG",
    },
    {
        name: "El Salvador",
        turkish_name: "El Salvador",
        dial_code: "+503",
        code: "SV",
    },
    {
        name: "Equatorial Guinea",
        turkish_name: "Ekvator Ginesi",
        dial_code: "+240",
        code: "GQ",
    },
    {
        name: "Eritrea",
        turkish_name: "Eritre",
        dial_code: "+291",
        code: "ER",
    },
    {
        name: "Estonia",
        turkish_name: "Estonya",
        dial_code: "+372",
        code: "EE",
    },
    {
        name: "Ethiopia",
        turkish_name: "Etiyopya",
        dial_code: "+251",
        code: "ET",
    },
    {
        name: "Falkland Islands (Malvinas)",
        turkish_name: "Falkland Adaları (Malvinas)",
        dial_code: "+500",
        code: "FK",
    },
    {
        name: "Faroe Islands",
        turkish_name: "Faroe Adaları",
        dial_code: "+298",
        code: "FO",
    },
    {
        name: "Fiji",
        turkish_name: "Fiji",
        dial_code: "+679",
        code: "FJ",
    },
    {
        name: "Finland",
        turkish_name: "Finlandiya",
        dial_code: "+358",
        code: "FI",
    },
    {
        name: "France",
        turkish_name: "Fransa",
        dial_code: "+33",
        code: "FR",
    },
    {
        name: "French Guiana",
        turkish_name: "Fransız Guyanası",
        dial_code: "+594",
        code: "GF",
    },
    {
        name: "French Polynesia",
        turkish_name: "Fransız Polinezyası",
        dial_code: "+689",
        code: "PF",
    },
    {
        name: "Gabon",
        turkish_name: "Gabon",
        dial_code: "+241",
        code: "GA",
    },
    {
        name: "Gambia",
        turkish_name: "Gambiya",
        dial_code: "+220",
        code: "GM",
    },
    {
        name: "Georgia",
        turkish_name: "Gürcistan",
        dial_code: "+995",
        code: "GE",
    },
    {
        name: "Germany",
        turkish_name: "Almanya",
        dial_code: "+49",
        code: "DE",
    },
    {
        name: "Ghana",
        turkish_name: "Gana",
        dial_code: "+233",
        code: "GH",
    },
    {
        name: "Gibraltar",
        turkish_name: "Cebelitarık",
        dial_code: "+350",
        code: "GI",
    },
    {
        name: "Greece",
        turkish_name: "Yunanistan",
        dial_code: "+30",
        code: "GR",
    },
    {
        name: "Greenland",
        turkish_name: "Grönland",
        dial_code: "+299",
        code: "GL",
    },
    {
        name: "Grenada",
        turkish_name: "Grenada",
        dial_code: "+1473",
        code: "GD",
    },
    {
        name: "Guadeloupe",
        turkish_name: "Guadeloupe",
        dial_code: "+590",
        code: "GP",
    },
    {
        name: "Guam",
        turkish_name: "Guam",
        dial_code: "+1671",
        code: "GU",
    },
    {
        name: "Guatemala",
        turkish_name: "Guatemala",
        dial_code: "+502",
        code: "GT",
    },
    {
        name: "Guernsey",
        turkish_name: "Guernsey",
        dial_code: "+44",
        code: "GG",
    },
    {
        name: "Guinea",
        turkish_name: "Gine",
        dial_code: "+224",
        code: "GN",
    },
    {
        name: "Guinea-Bissau",
        turkish_name: "Gine-Bissau",
        dial_code: "+245",
        code: "GW",
    },
    {
        name: "Guyana",
        turkish_name: "Guyana",
        dial_code: "+595",
        code: "GY",
    },
    {
        name: "Haiti",
        turkish_name: "Haiti",
        dial_code: "+509",
        code: "HT",
    },
    {
        name: "Holy See (Vatican City State)",
        turkish_name: "Vatikan",
        dial_code: "+379",
        code: "VA",
    },
    {
        name: "Honduras",
        turkish_name: "Honduras",
        dial_code: "+504",
        code: "HN",
    },
    {
        name: "Hong Kong",
        turkish_name: "Hong Kong",
        dial_code: "+852",
        code: "HK",
    },
    {
        name: "Hungary",
        turkish_name: "Macaristan",
        dial_code: "+36",
        code: "HU",
    },
    {
        name: "Iceland",
        turkish_name: "İzlanda",
        dial_code: "+354",
        code: "IS",
    },
    {
        name: "India",
        turkish_name: "Hindistan",
        dial_code: "+91",
        code: "IN",
    },
    {
        name: "Indonesia",
        turkish_name: "Endonezya",
        dial_code: "+62",
        code: "ID",
    },
    {
        name: "Iran, Islamic Republic of Persian Gulf",
        turkish_name: "İran",
        dial_code: "+98",
        code: "IR",
    },
    {
        name: "Iraq",
        turkish_name: "Irak",
        dial_code: "+964",
        code: "IQ",
    },
    {
        name: "Ireland",
        turkish_name: "İrlanda",
        dial_code: "+353",
        code: "IE",
    },
    {
        name: "Isle of Man",
        turkish_name: "Man Adası",
        dial_code: "+44",
        code: "IM",
    },
    {
        name: "Israel",
        turkish_name: "İsrail",
        dial_code: "+972",
        code: "IL",
    },
    {
        name: "Italy",
        turkish_name: "İtalya",
        dial_code: "+39",
        code: "IT",
    },
    {
        name: "Jamaica",
        turkish_name: "Jamaika",
        dial_code: "+1876",
        code: "JM",
    },
    {
        name: "Japan",
        turkish_name: "Japonya",
        dial_code: "+81",
        code: "JP",
    },
    {
        name: "Jersey",
        turkish_name: "Jersey",
        dial_code: "+44",
        code: "JE",
    },
    {
        name: "Jordan",
        turkish_name: "Ürdün",
        dial_code: "+962",
        code: "JO",
    },
    {
        name: "Kazakhstan",
        turkish_name: "Kazakistan",
        dial_code: "+77",
        code: "KZ",
    },
    {
        name: "Kenya",
        turkish_name: "Kenya",
        dial_code: "+254",
        code: "KE",
    },
    {
        name: "Kiribati",
        turkish_name: "Kiribati",
        dial_code: "+686",
        code: "KI",
    },
    {
        name: "Kosovo",
        turkish_name: "Kosova",
        dial_code: "+383",
        code: "XK",
    },
    {
        name: "Korea, Democratic People's Republic of Korea",
        turkish_name: "Kuzey Kore",
        dial_code: "+850",
        code: "KP",
    },
    {
        name: "Korea, Republic of South Korea",
        turkish_name: "Güney Kore",
        dial_code: "+82",
        code: "KR",
    },
    {
        name: "Kuwait",
        turkish_name: "Kuveyt",
        dial_code: "+965",
        code: "KW",
    },
    {
        name: "Kyrgyzstan",
        turkish_name: "Kırgızistan",
        dial_code: "+996",
        code: "KG",
    },
    {
        name: "Laos",
        turkish_name: "Laos",
        dial_code: "+856",
        code: "LA",
    },
    {
        name: "Latvia",
        turkish_name: "Letonya",
        dial_code: "+371",
        code: "LV",
    },
    {
        name: "Lebanon",
        turkish_name: "Lübnan",
        dial_code: "+961",
        code: "LB",
    },
    {
        name: "Lesotho",
        turkish_name: "Lesotho",
        dial_code: "+266",
        code: "LS",
    },
    {
        name: "Liberia",
        turkish_name: "Liberya",
        dial_code: "+231",
        code: "LR",
    },
    {
        name: "Libyan Arab Jamahiriya",
        turkish_name: "Libya",
        dial_code: "+218",
        code: "LY",
    },
    {
        name: "Liechtenstein",
        turkish_name: "Lihtenştayn",
        dial_code: "+423",
        code: "LI",
    },
    {
        name: "Lithuania",
        turkish_name: "Litvanya",
        dial_code: "+370",
        code: "LT",
    },
    {
        name: "Luxembourg",
        turkish_name: "Lüksemburg",
        dial_code: "+352",
        code: "LU",
    },
    {
        name: "Macao",
        turkish_name: "Makao",
        dial_code: "+853",
        code: "MO",
    },
    {
        name: "Macedonia",
        turkish_name: "Makedonya",
        dial_code: "+389",
        code: "MK",
    },
    {
        name: "Madagascar",
        turkish_name: "Madagaskar",
        dial_code: "+261",
        code: "MG",
    },
    {
        name: "Malawi",
        turkish_name: "Malavi",
        dial_code: "+265",
        code: "MW",
    },
    {
        name: "Malaysia",
        turkish_name: "Malezya",
        dial_code: "+60",
        code: "MY",
    },
    {
        name: "Maldives",
        turkish_name: "Maldivler",
        dial_code: "+960",
        code: "MV",
    },
    {
        name: "Mali",
        turkish_name: "Mali",
        dial_code: "+223",
        code: "ML",
    },
    {
        name: "Malta",
        turkish_name: "Malta",
        dial_code: "+356",
        code: "MT",
    },
    {
        name: "Marshall Islands",
        turkish_name: "Marshall Adaları",
        dial_code: "+692",
        code: "MH",
    },
    {
        name: "Martinique",
        turkish_name: "Martinik",
        dial_code: "+596",
        code: "MQ",
    },
    {
        name: "Mauritania",
        turkish_name: "Moritanya",
        dial_code: "+222",
        code: "MR",
    },
    {
        name: "Mauritius",
        turkish_name: "Mauritius",
        dial_code: "+230",
        code: "MU",
    },
    {
        name: "Mayotte",
        turkish_name: "Mayotte",
        dial_code: "+262",
        code: "YT",
    },
    {
        name: "Mexico",
        turkish_name: "Meksika",
        dial_code: "+52",
        code: "MX",
    },
    {
        name: "Micronesia, Federated States of Micronesia",
        turkish_name: "Mikronezya",
        dial_code: "+691",
        code: "FM",
    },
    {
        name: "Moldova",
        turkish_name: "Moldova",
        dial_code: "+373",
        code: "MD",
    },
    {
        name: "Monaco",
        turkish_name: "Monako",
        dial_code: "+377",
        code: "MC",
    },
    {
        name: "Mongolia",
        turkish_name: "Moğolistan",
        dial_code: "+976",
        code: "MN",
    },
    {
        name: "Montenegro",
        turkish_name: "Karadağ",
        dial_code: "+382",
        code: "ME",
    },
    {
        name: "Montserrat",
        turkish_name: "Montserrat",
        dial_code: "+1664",
        code: "MS",
    },
    {
        name: "Morocco",
        turkish_name: "Fas",
        dial_code: "+212",
        code: "MA",
    },
    {
        name: "Mozambique",
        turkish_name: "Mozambik",
        dial_code: "+258",
        code: "MZ",
    },
    {
        name: "Myanmar",
        turkish_name: "Myanmar",
        dial_code: "+95",
        code: "MM",
    },
    {
        name: "Namibia",
        turkish_name: "Namibya",
        dial_code: "+264",
        code: "NA",
    },
    {
        name: "Nauru",
        turkish_name: "Nauru",
        dial_code: "+674",
        code: "NR",
    },
    {
        name: "Nepal",
        turkish_name: "Nepal",
        dial_code: "+977",
        code: "NP",
    },
    {
        name: "Netherlands",
        turkish_name: "Hollanda",
        dial_code: "+31",
        code: "NL",
    },
    {
        name: "Netherlands Antilles",
        turkish_name: "Hollanda Antilleri",
        dial_code: "+599",
        code: "AN",
    },
    {
        name: "New Caledonia",
        turkish_name: "Yeni Kaledonya",
        dial_code: "+687",
        code: "NC",
    },
    {
        name: "New Zealand",
        turkish_name: "Yeni Zelanda",
        dial_code: "+64",
        code: "NZ",
    },
    {
        name: "Nicaragua",
        turkish_name: "Nikaragua",
        dial_code: "+505",
        code: "NI",
    },
    {
        name: "Niger",
        turkish_name: "Nijer",
        dial_code: "+227",
        code: "NE",
    },
    {
        name: "Nigeria",
        turkish_name: "Nijerya",
        dial_code: "+234",
        code: "NG",
    },
    {
        name: "Niue",
        turkish_name: "Niue",
        dial_code: "+683",
        code: "NU",
    },
    {
        name: "Norfolk Island",
        turkish_name: "Norfolk Adası",
        dial_code: "+672",
        code: "NF",
    },
    {
        name: "Northern Mariana Islands",
        turkish_name: "Kuzey Mariana Adaları",
        dial_code: "+1670",
        code: "MP",
    },
    {
        name: "Norway",
        turkish_name: "Norveç",
        dial_code: "+47",
        code: "NO",
    },
    {
        name: "Oman",
        turkish_name: "Umman",
        dial_code: "+968",
        code: "OM",
    },
    {
        name: "Pakistan",
        turkish_name: "Pakistan",
        dial_code: "+92",
        code: "PK",
    },
    {
        name: "Palau",
        turkish_name: "Palau",
        dial_code: "+680",
        code: "PW",
    },
    {
        name: "Palestinian Territory, Occupied",
        turkish_name: "Filistin",
        dial_code: "+970",
        code: "PS",
    },
    {
        name: "Panama",
        turkish_name: "Panama",
        dial_code: "+507",
        code: "PA",
    },
    {
        name: "Papua New Guinea",
        turkish_name: "Papua Yeni Gine",
        dial_code: "+675",
        code: "PG",
    },
    {
        name: "Paraguay",
        turkish_name: "Paraguay",
        dial_code: "+595",
        code: "PY",
    },
    {
        name: "Peru",
        turkish_name: "Peru",
        dial_code: "+51",
        code: "PE",
    },
    {
        name: "Philippines",
        turkish_name: "Filipinler",
        dial_code: "+63",
        code: "PH",
    },
    {
        name: "Pitcairn",
        turkish_name: "Pitcairn Adaları",
        dial_code: "+872",
        code: "PN",
    },
    {
        name: "Poland",
        turkish_name: "Polonya",
        dial_code: "+48",
        code: "PL",
    },
    {
        name: "Portugal",
        turkish_name: "Portekiz",
        dial_code: "+351",
        code: "PT",
    },
    {
        name: "Puerto Rico",
        turkish_name: "Porto Riko",
        dial_code: "+1939",
        code: "PR",
    },
    {
        name: "Qatar",
        turkish_name: "Katar",
        dial_code: "+974",
        code: "QA",
    },
    {
        name: "Romania",
        turkish_name: "Romanya",
        dial_code: "+40",
        code: "RO",
    },
    {
        name: "Russia",
        turkish_name: "Rusya",
        dial_code: "+7",
        code: "RU",
    },
    {
        name: "Rwanda",
        turkish_name: "Ruanda",
        dial_code: "+250",
        code: "RW",
    },
    {
        name: "Reunion",
        turkish_name: "Reunion",
        dial_code: "+262",
        code: "RE",
    },
    {
        name: "Saint Barthelemy",
        turkish_name: "Saint Barthelemy",
        dial_code: "+590",
        code: "BL",
    },
    {
        name: "Saint Helena, Ascension and Tristan Da Cunha",
        turkish_name: "Saint Helena, Ascension ve Tristan Da Cunha",
        dial_code: "+290",
        code: "SH",
    },
    {
        name: "Saint Kitts and Nevis",
        turkish_name: "Saint Kitts ve Nevis",
        dial_code: "+1869",
        code: "KN",
    },
    {
        name: "Saint Lucia",
        turkish_name: "Saint Lucia",
        dial_code: "+1758",
        code: "LC",
    },
    {
        name: "Saint Martin",
        turkish_name: "Saint Martin",
        dial_code: "+590",
        code: "MF",
    },
    {
        name: "Saint Pierre and Miquelon",
        turkish_name: "Saint Pierre ve Miquelon",
        dial_code: "+508",
        code: "PM",
    },
    {
        name: "Saint Vincent and the Grenadines",
        turkish_name: "Saint Vincent ve Grenadinler",
        dial_code: "+1784",
        code: "VC",
    },
    {
        name: "Samoa",
        turkish_name: "Samoa",
        dial_code: "+685",
        code: "WS",
    },
    {
        name: "San Marino",
        turkish_name: "San Marino",
        dial_code: "+378",
        code: "SM",
    },
    {
        name: "Sao Tome and Principe",
        turkish_name: "Sao Tome ve Principe",
        dial_code: "+239",
        code: "ST",
    },
    {
        name: "Saudi Arabia",
        turkish_name: "Suudi Arabistan",
        dial_code: "+966",
        code: "SA",
    },
    {
        name: "Senegal",
        turkish_name: "Senegal",
        dial_code: "+221",
        code: "SN",
    },
    {
        name: "Serbia",
        turkish_name: "Sırbistan",
        dial_code: "+381",
        code: "RS",
    },
    {
        name: "Seychelles",
        turkish_name: "Seyşeller",
        dial_code: "+248",
        code: "SC",
    },
    {
        name: "Sierra Leone",
        turkish_name: "Sierra Leone",
        dial_code: "+232",
        code: "SL",
    },
    {
        name: "Singapore",
        turkish_name: "Singapur",
        dial_code: "+65",
        code: "SG",
    },
    {
        name: "Slovakia",
        turkish_name: "Slovakya",
        dial_code: "+421",
        code: "SK",
    },
    {
        name: "Slovenia",
        turkish_name: "Slovenya",
        dial_code: "+386",
        code: "SI",
    },
    {
        name: "Solomon Islands",
        turkish_name: "Solomon Adaları",
        dial_code: "+677",
        code: "SB",
    },
    {
        name: "Somalia",
        turkish_name: "Somali",
        dial_code: "+252",
        code: "SO",
    },
    {
        name: "South Africa",
        turkish_name: "Güney Afrika",
        dial_code: "+27",
        code: "ZA",
    },
    {
        name: "South Sudan",
        turkish_name: "Güney Sudan",
        dial_code: "+211",
        code: "SS",
    },
    {
        name: "South Georgia and the South Sandwich Islands",
        turkish_name: "Güney Georgia ve Güney Sandwich Adaları",
        dial_code: "+500",
        code: "GS",
    },
    {
        name: "Spain",
        turkish_name: "İspanya",
        dial_code: "+34",
        code: "ES",
    },
    {
        name: "Sri Lanka",
        turkish_name: "Sri Lanka",
        dial_code: "+94",
        code: "LK",
    },
    {
        name: "Sudan",
        turkish_name: "Sudan",
        dial_code: "+249",
        code: "SD",
    },
    {
        name: "Suriname",
        turkish_name: "Surinam",
        dial_code: "+597",
        code: "SR",
    },
    {
        name: "Svalbard and Jan Mayen",
        turkish_name: "Svalbard ve Jan Mayen",
        dial_code: "+47",
        code: "SJ",
    },
    {
        name: "Swaziland",
        turkish_name: "Esvatini",
        dial_code: "+268",
        code: "SZ",
    },
    {
        name: "Sweden",
        turkish_name: "İsveç",
        dial_code: "+46",
        code: "SE",
    },
    {
        name: "Switzerland",
        turkish_name: "İsviçre",
        dial_code: "+41",
        code: "CH",
    },
    {
        name: "Syrian Arab Republic",
        turkish_name: "Suriye",
        dial_code: "+963",
        code: "SY",
    },
    {
        name: "Taiwan",
        turkish_name: "Tayvan",
        dial_code: "+886",
        code: "TW",
    },
    {
        name: "Tajikistan",
        turkish_name: "Tacikistan",
        dial_code: "+992",
        code: "TJ",
    },
    {
        name: "Tanzania, United Republic of Tanzania",
        turkish_name: "Tanzanya",
        dial_code: "+255",
        code: "TZ",
    },
    {
        name: "Thailand",
        turkish_name: "Tayland",
        dial_code: "+66",
        code: "TH",
    },
    {
        name: "Timor-Leste",
        turkish_name: "Doğu Timor",
        dial_code: "+670",
        code: "TL",
    },
    {
        name: "Togo",
        turkish_name: "Togo",
        dial_code: "+228",
        code: "TG",
    },
    {
        name: "Tokelau",
        turkish_name: "Tokelau",
        dial_code: "+690",
        code: "TK",
    },
    {
        name: "Tonga",
        turkish_name: "Tonga",
        dial_code: "+676",
        code: "TO",
    },
    {
        name: "Trinidad and Tobago",
        turkish_name: "Trinidad ve Tobago",
        dial_code: "+1868",
        code: "TT",
    },
    {
        name: "Tunisia",
        turkish_name: "Tunus",
        dial_code: "+216",
        code: "TN",
    },
    {
        name: "Turkey",
        turkish_name: "Türkiye",
        dial_code: "+90",
        code: "TR",
    },
    {
        name: "Turkmenistan",
        turkish_name: "Türkmenistan",
        dial_code: "+993",
        code: "TM",
    },
    {
        name: "Turks and Caicos Islands",
        turkish_name: "Turks ve Caicos Adaları",
        dial_code: "+1649",
        code: "TC",
    },
    {
        name: "Tuvalu",
        turkish_name: "Tuvalu",
        dial_code: "+688",
        code: "TV",
    },
    {
        name: "Uganda",
        turkish_name: "Uganda",
        dial_code: "+256",
        code: "UG",
    },
    {
        name: "Ukraine",
        turkish_name: "Ukrayna",
        dial_code: "+380",
        code: "UA",
    },
    {
        name: "United Arab Emirates",
        turkish_name: "Birleşik Arap Emirlikleri",
        dial_code: "+971",
        code: "AE",
    },
    {
        name: "United Kingdom",
        turkish_name: "Birleşik Krallık",
        dial_code: "+44",
        code: "GB",
    },
    {
        name: "United States",
        turkish_name: "Amerika Birleşik Devletleri",
        dial_code: "+1",
        code: "US",
    },
    {
        name: "Uruguay",
        turkish_name: "Uruguay",
        dial_code: "+598",
        code: "UY",
    },
    {
        name: "Uzbekistan",
        turkish_name: "Özbekistan",
        dial_code: "+998",
        code: "UZ",
    },
    {
        name: "Vanuatu",
        turkish_name: "Vanuatu",
        dial_code: "+678",
        code: "VU",
    },
    {
        name: "Venezuela, Bolivarian Republic of Venezuela",
        turkish_name: "Venezuela",
        dial_code: "+58",
        code: "VE",
    },
    {
        name: "Vietnam",
        turkish_name: "Vietnam",
        dial_code: "+84",
        code: "VN",
    },
    {
        name: "Virgin Islands, British",
        turkish_name: "Britanya Virjin Adaları",
        dial_code: "+1284",
        code: "VG",
    },
    {
        name: "Virgin Islands, U.S.",
        turkish_name: "ABD Virjin Adaları",
        dial_code: "+1340",
        code: "VI",
    },
    {
        name: "Wallis and Futuna",
        turkish_name: "Wallis ve Futuna",
        dial_code: "+681",
        code: "WF",
    },
    {
        name: "Yemen",
        turkish_name: "Yemen",
        dial_code: "+967",
        code: "YE",
    },
    {
        name: "Zambia",
        turkish_name: "Zambiya",
        dial_code: "+260",
        code: "ZM",
    },
    {
        name: "Zimbabwe",
        turkish_name: "Zimbabve",
        dial_code: "+263",
        code: "ZW",
    },
];
export default countries;